<template>
  <section class="index-list-wrap">
    <div class="index-list-center">
      <div class="index-list-top">
        <hgroup>
          <h2>{{$tt('所有款式')}}</h2>
          <h3></h3>
        </hgroup>
        <div>
          <button class="is-grid" :class="isFilterActive() ? 'is-active' : ''" @click="setFilterActive(true)"></button>
          <button class="is-masonry" :class="!isFilterActive() ? 'is-active' : ''" @click="setFilterActive(false)"></button>
        </div>
      </div>
      <div class="index-list-main" :class="isFilterActive() ? '' : 'is-masonry'">
        <div v-for="template in getActiveTemplateFilter" :key="template.pd_id">
          <Item :data="template"> </Item>
        </div>
      </div>
    </div>
  </section>
</template>

<script type="application/javascript">
import config from '../config';
import { mapGetters } from "vuex";
import Item from './Item.vue';

export default {
    data: function () {
      return {
        templateData : [],
        filterActive: false
      }
    },
    components: {
      Item
    },
    computed: {
      ...mapGetters([        
        'getActiveTemplateFilter'
      ]),
      
    },
    mounted: function() {
      this.filterActive = true;
     
    },
    
    methods: {
      isFilterActive() {
        return this.filterActive
      },
      setFilterActive(isActive){
        this.filterActive = isActive
      }
    }
    
};
</script>
